import React from 'react';
import { IconButton } from '@mui/material';
import { Check, ContentCopy } from '@mui/icons-material';
import { copyTextToClipboard } from '../utils/clipboard';

// The chat header's "BR:" is the booking's order_ref. For Ventrata that is the ORDER's reference; the booking's own
// one (Ventrata's "Booking Ref") comes as booking_ref in the conversation's subject_gtus_ref_details. Agents paste
// these into their messages (Walks Devour, 2026-10-26), so the header's tooltip lists each with a copy button, and the
// reseller's own reference (e.g. GetYourGuide's) too (2026-10-27).

// details: subject_gtus_ref_details; refs: subject_gtus_booking_refs, all that an older backend sends.
export function bookingRefRows(details, refs) {
    const rows = details?.length
        ? details.flatMap(d => {
            const shown = d.booking_ref
                ? [{ label: 'Booking ref', value: d.booking_ref }, { label: 'Order #', value: d.order_ref }]
                : [{ label: 'BR', value: d.order_ref || d.reseller_ref }];
            // Without an order_ref, "BR" already is the reseller ref.
            return d.reseller_ref && !shown.some(r => r.value === d.reseller_ref)
                ? [...shown, { label: 'Reseller ref', value: d.reseller_ref }]
                : shown;
        })
        : (refs || []).map(value => ({ label: 'BR', value }));
    const seen = new Set();
    return rows.filter(r => {
        const key = `${r.label}\n${r.value}`;
        if (!r.value || seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}

// Tooltip title: MUI v5 tooltips stay open while the pointer is over them, so the buttons can be reached.
export function BookingRefsTooltipContent({ rows }) {
    const [copied, setCopied] = React.useState(null);
    const mounted = React.useRef(true);
    React.useEffect(() => () => { mounted.current = false; }, []);
    React.useEffect(() => {
        if (copied === null) return undefined;
        const t = setTimeout(() => setCopied(null), 1500);
        return () => clearTimeout(t);
    }, [copied]);

    const copy = (e, idx, value) => {
        e.stopPropagation();
        copyTextToClipboard(value).then(ok => {
            if (ok && mounted.current) setCopied(idx);
        });
    };

    return (
        <span style={{ display: 'flex', flexDirection: 'column' }}>
            {rows.map((r, idx) => (
                <span key={idx} style={{ display: 'flex', alignItems: 'center', gap: 4, userSelect: 'text' }}>
                    {r.label}: {r.value}
                    <IconButton
                        size="small"
                        aria-label={`Copy ${r.label} ${r.value}`}
                        onClick={e => copy(e, idx, r.value)}
                        style={{ color: 'inherit', padding: 2 }}
                    >
                        {copied === idx ? <Check style={{ fontSize: 14 }} /> : <ContentCopy style={{ fontSize: 14 }} />}
                    </IconButton>
                </span>
            ))}
        </span>
    );
}
